import { quickAccessTypes } from '@/homepage/components/homepage-quick-access/quick-access.constants';
import { getItemsWithSummaries } from '@/homepage/homepage.api.js';
import uniqBy from 'lodash/uniqBy';

export function itemRoute (type, subType, id) {
    const typeDetails = quickAccessTypes()[type][subType] ?? quickAccessTypes()[type].default;

    const { routeName, routeIdParam } = typeDetails || {};

    switch (type) {
        case 'SavedView':
            if (subType === 'feedback') {
                return { name: routeName, params: { [routeIdParam]: id, tab: 'insights' } };
            }
            if (subType === 'replaylibrary') {
                return { name: routeName, params: { [routeIdParam]: id } };
            }
            throw new Error(`Route not found for SavedView::${subType}`);
        case 'Segment':
            return { name: routeName, query: { segment: id } };
        case 'VocItem':
            return { name: routeName, query: { openItem: id } };
        default:
            return { name: routeName, params: { [routeIdParam]: id } };
    }
}

export async function itemHistoryAndFavoritesWithSummaries (allItemHistory, stars = []) {
    const starredItems = Object.values(stars)?.reduce((acc, item) => {
        if (item.starred) {
            acc.unshift({ id: item.itemId, type: item.itemType });
        }

        return acc;
    }, []);

    const itemsWithoutSummaries = uniqBy(starredItems.concat(allItemHistory), 'id');

    const itemsWithSummaries = await getItemsWithSummaries(itemsWithoutSummaries);

    const recents = allItemHistory.reduce((acc, item) => {
        if (itemsWithSummaries[item.id]) {
            const recent = itemsWithSummaries[item.id];
            const typeDetails =
                quickAccessTypes()[recent.type]?.[recent.subType] ?? quickAccessTypes()[recent.type]?.default;

            if (typeDetails) {
                acc.push({
                    ...recent,
                    icon: typeDetails.icon,
                    route: itemRoute(recent.type, recent.subType, recent.id),
                    label: typeDetails.label,
                });
            }
        }

        return acc;
    }, []);

    const favorites = starredItems.reduce((acc, item) => {
        if (itemsWithSummaries[item.id]) {
            const favorite = itemsWithSummaries[item.id];
            const typeDetails =
                quickAccessTypes()[favorite.type]?.[favorite.subType] ?? quickAccessTypes()[favorite.type]?.default;

            if (typeDetails) {
                acc.push({
                    ...favorite,
                    icon: typeDetails.icon,
                    route: itemRoute(favorite.type, favorite.subType, favorite.id),
                    label: typeDetails.label,
                });
            }
        }

        return acc;
    }, []);

    return { favorites, recents };
}
